<template>
  <div>
    <v-card outlined flat>
      <v-app-bar color="primary" short dense dark flat>
        <v-toolbar-title>Riwayat Organisasi</v-toolbar-title>
        <v-spacer></v-spacer>

        <div class="mr-3 mt-1">
          <rworganisasiModalAdd />
        </div>

        <div style="max-width: 300px;">
          <v-tabs v-model="tab" right dark background-color="primary">
            <v-tab href="#tab-1" @click="getSIMASN()">
              <h5>IDASN</h5>
            </v-tab>

            <!-- <v-tab href="#tab-2" @click="getSAPK()">
              <h5>SAPK</h5>
            </v-tab> -->
          </v-tabs>
        </div>
      </v-app-bar>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-1" class="pa-5">
          <rworganisasiSIMASN />
        </v-tab-item>
        <!-- <v-tab-item value="tab-2" class="pa-5">
          <rworganisasiSAPK />
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import getData from '@/store/asn/rworganisasi/tabs'
import rworganisasiSIMASN from '@/components/asn/profil/rworganisasi/rworganisasi'
// import rworganisasiSAPK from '@/components/asn/profil/rworganisasi/SAPK_rworganisasi_Modal'
import rworganisasiModalAdd from '@/components/asn/profil/rworganisasi/ModalAdd'

export default {
  name: 'DataUtama',

  components: {
    rworganisasiSIMASN,
    // rworganisasiSAPK,
    rworganisasiModalAdd
  },

  computed: {
    dataSAPK: {
      get() {
        return getData.state.tabSAPK
      },

      set(value) {
        getData.commit('getSAPK', value)
      }
    }
  },

  data: () => ({
    tab: null
  }),

  methods: {
    getSAPK() {
      getData.commit('getSAPK', true)
      getData.commit('getSIMASN', false)
    },
    getSIMASN() {
      getData.commit('getSIMASN', true)
      getData.commit('getSAPK', false)
    }
  }
}
</script>
